<template>
  <div class="cotainer card-item">
    <div class="card-title">
      <div class="title-box">
        <span class="title-text">{{ cardTitle }}</span>
      </div>
      <div class="title-boxs">
        <span class="btn-action-group">
          <a-button
            type="primary"
            @click="addSource()"
            class="btn-action"
            v-if="oldInfos?.id && !isEdit"
            >新增</a-button
          >
          <!-- <a-button
            class="btn-action"
            type="primary"
            v-if="oldInfos?.id"
            @click="showevidence"
          >
            佐证材料</a-button
          > -->
          <a-button
            @click="importsj(1)"
            class="btn-action"
            v-if="oldInfos?.id && !isEdit"
            >导入</a-button
          >
          <!-- <a-button
            class="btn-action"
            danger
            type="text"
            @click="batchDelete"
            v-if="oldInfos?.id && !isEdit"
          >
            批量移除</a-button
          > -->
        </span>
      </div>
    </div>

    <div class="cotainerfottter">
      <a-table
        style="text-align: center"
        :locale="{ emptyText }"
        :columns="columns"
        :data-source="dataList"
        :loading="loading"
        @change="handleTableChange"
        :pagination="pagination"
        :bordered="true"
        rowKey="id"
      >
        <!-- :scroll="{ y: 290 }"
        :row-selection="rowSelection" -->

        <template slot="status" slot-scope="text, record, index">
          <!-- :defaultVisible="true" -->
          <a-tooltip placement="right" v-if="record.status != '2'">
            <template slot="title">
              <span v-if="record.operation == 'INSERT'">
                <div>新增当前数据</div>
                <div
                  v-for="item in insertDiff(record)"
                  :key="item.key || item.field"
                  style="
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                  "
                >
                  {{ item.field }}：{{ item.obj2 }}
                </div>
              </span>
              <span v-if="record.operation == 'UPDATE'">
                <div
                  style="
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                  "
                >
                  属性名称：原数据<span style="color: #3498db; font-size: 20px"
                    >→</span
                  >新数据
                </div>
                <div
                  v-for="item in diff(
                    record.changeTransContent,
                    record.nowTransContent
                  )"
                  style="
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                  "
                >
                  {{ item.field }}:<span>{{ item.obj1 }}</span>
                  <span style="color: #3498db; font-size: 20px">→</span
                  ><span>{{ item.obj2 }}</span>
                </div>
              </span>
              <span v-if="record.operation == 'DELETE'">删除当前数据.</span>
              <span v-if="text == '3'">驳回原因:{{ record.remark }}</span>
            </template>
            <div class="statuswz">
              <img
                src="@/assets/images/newadd.png"
                v-if="record.operation == 'INSERT'"
                title="新增"
              />
              <img
                src="@/assets/images/newedit.png"
                v-if="record.operation == 'UPDATE'"
                title="编辑"
              />
              <img
                src="@/assets/images/newdelete.png"
                v-if="record.operation == 'DELETE'"
                title="删除"
              />
              <!-- <img src="@/assets/images/back.png" v-if="record.operation==''" title="正确" /> -->
              <img
                src="@/assets/images/right.png"
                v-if="record.operation == ''"
                title="正常数据"
              />
              <div class="status-code status-orange" v-if="text == '0'"></div>
              <div class="status-code" v-if="text == '1'"></div>
              <div class="status-code status-red" v-if="text == '3'"></div>
              <div class="status-code status-gray" v-if="text == '4'"></div>
            </div>
          </a-tooltip>
          <div class="statuswz" v-else>
            <img src="@/assets/images/right.png" title="正确" />
          </div>
        </template>
        <template slot="sequenceNumber" slot-scope="text, record, index">
          <!-- 如果不需要分页或分页信息不存在，直接使用 index + 1 -->
          <span v-if="!pagination || !pagination.pageSize">{{
            index + 1
          }}</span>
          <!-- 否则计算全局序号 -->
          <span v-else>{{
            (pagination.current - 1) * pagination.pageSize + index + 1
          }}</span>
        </template>
        <template
          style="width: 100px"
          slot="capitalSource"
          slot-scope="text, record"
        >
          <tr
            v-for="(item, index) in record.lxSubsidyFundCostList"
            :key="index"
            :style="
              index + 1 == record.lxSubsidyFundCostList.length
                ? ''
                : 'border-bottom: 1px solid #e8e8e8;'
            "
            class="table-tr"
          >
            <div class="table-content" :title="item.project">
              <span>{{ item.project }}</span>
            </div>
          </tr>
          <span v-if="record.lxSubsidyFundCostList.length == 0">-</span>
        </template>
        <template style="width: 100px" slot="name" slot-scope="text, record">
          <tr
            v-for="(item, index) in record.lxSubsidyFundCostList"
            :key="index"
            :style="
              index + 1 == record.lxSubsidyFundCostList.length
                ? ''
                : 'border-bottom: 1px solid #e8e8e8;'
            "
            class="table-tr"
          >
            <div class="table-content" :title="item.amount">
              <span>{{ item.amount }}</span>
            </div>
          </tr>
          <span v-if="record.lxSubsidyFundCostList.length == 0">-</span>
        </template>
        <span
          class="flex flex-around flex-wrap"
          slot="action"
          slot-scope="record"
        >
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            v-if="oldInfos && oldInfos.id"
            @click="showevidence(record)"
          >
            <img class="img-box" src="../../assets/images/imgcl.png" alt="" />
            <span>佐证材料</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            v-if="
              oldInfos &&
              oldInfos.id &&
              !isEdit &&
              record?.operation != 'DELETE' &&
              record?.status != '1' &&
              record?.status != '3'
            "
            @click="editInfo(record)"
          >
            <img class="img-box" src="../../assets/images/img42.png" alt="" />
            <span>编辑</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            v-if="
              oldInfos && oldInfos.id && !isEdit && !record?.operation
            "
            @click="deleteInfo(record)"
          >
            <img class="img-box" src="../../assets/images/img43.png" alt="" />
            <span>移除</span>
          </div>

          <div
            class="flex align-items-center"
            style="cursor: pointer"
            v-if="oldInfos && oldInfos.id && !isEdit && record?.operation"
            @click="cancelInfo(record)"
          >
            <img class="img-box" src="@/assets/images/cx.png" alt="" />
            <span>撤销</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            v-if="oldInfos && oldInfos.id && isEdit"
            @click="seeInfo(record)"
          >
            <img class="img-box" src="../../assets/images/img42.png" alt="" />
            <span>查看</span>
          </div>
        </span>
        <!-- <template
          slot="action"
          slot-scope="record"
          style="margin: 0 20px"
          v-if="oldInfos?.id  && !isEdit"
        >
          <tr class="table-tr">
            <div
              class="table-content"
              style="
                justify-content: space-between;
                padding: 0px 50px;
                box-sizing: border-box;
              "
            >
              <div
                class="flex align-items-center"
                style="cursor: pointer"
                @click="editInfo(record, index)"
              >
                <img
                  class="img-box"
                  src="../../assets/images/img42.png"
                  alt=""
                />
                <span>编辑</span>
              </div>
              <div
                class="flex align-items-center"
                style="cursor: pointer"
                @click="deleteInfo(record, index)"
              >
                <img
                  class="img-box"
                  src="../../assets/images/img43.png"
                  alt=""
                />
                <span>移除</span>
              </div>
            </div>
          </tr>
        </template> -->
      </a-table>
    </div>
    <!-- 添加资金来源 -->
    <found-source ref="foundSource" @foundPay="foundPay"></found-source>
    <a-modal
      title="您确定移除吗"
      :visible="showDeleteModel"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="showDeleteModel = false"
    >
      <p v-if="sj?.status == '1'">您确定要移除待审核的这条数据吗?</p>
      <p v-else-if="sj?.status == '4'">您确定要移除已撤销的这条数据吗?</p>
      <p v-else>您确定要移除该条预算的数据吗?</p>
    </a-modal>
    <a-modal
      title="您确定撤销吗"
      :visible="showCancelModel"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOks"
      @cancel="showCancelModel = false"
    >
      <p v-if="sj?.status == '1'">您确定要撤销待审核的这条数据吗?</p>
      <p v-else-if="sj?.status == '3'">您确定要撤销已驳回的这条数据吗?</p>
      <p v-else>您确定要撤销当前提交的数据吗?</p>
    </a-modal>
    <data-import ref="dataImport" @refreshData="foundPay"></data-import>
    <div class="preview-pop-box" v-if="showtable">
      <div class="preview-boxs">
        <evidencelist
          :title="title"
          :isEdit="isEdit"
          :id="id"
          :dataid="sj.id"
          @closePreview="showtable = false"
        >
        </evidencelist>
      </div>
    </div>
  </div>
</template>

<script>
import { getAction, postAction, putAction, deleteAction } from "@/api/index";
import dataImport from "@/components/common/dataImport.vue";
import evidencelist from "@/components/common/evidencelist";
import foundSource from "./addSource.vue";
import { FIELD_LABELS } from "@/components/auditPage/data.js";
import mixin from "@/utils/mixin";
import changeStatusMixin from '@/utils/changeStatusMixin';
import brandListValidate from "./brandListValidate";
const columns = [
  {
    title: "序号",
    dataIndex: "sequenceNumber",
    id: "sequenceNumber",
    align: "center",
    scopedSlots: { customRender: "sequenceNumber" },
    width: 70,
  },
  {
    title: "年份",
    dataIndex: "vintages",
    id: "vintages",
    align: "center",
    width: 150,
  },
  // {
  // 	title: "资金名称",
  // 	dataIndex: "name",
  // 	id: "name",
  // 	align: "center",
  // 	width: 150,
  // },
  {
    title: "资金来源",
    dataIndex: "capitalSource_dictText",
    id: "capitalSource_dictText",
    align: "center",
    width: 180,
  },
  {
    title: "资金金额",
    dataIndex: "amount",
    id: "amount",
    align: "center",
    width: 160,
  },
  // 	{
  // 	title: "支出项目",
  // 	dataIndex: "createTime",
  // 	id: "createTime",
  // 	align: "center",
  // 	width: 150,
  // 	scopedSlots: { customRender: "capitalSource" },
  // },
  // {
  //   title: "剩余金额",
  //   dataIndex: "surplusAmount",
  //   id: "surplusAmount",
  //   align: "center",
  //   width: 150,
  // },
  {
    title: "操作",
    id: "action",
    align: "center",
    width: 300,
    scopedSlots: { customRender: "action" },
  },
];
export default {
  mixins: [
    changeStatusMixin,
    mixin,
    brandListValidate("请添加品牌资金预算", {
      requiredFields: ["vintages", "capitalSource", "amount"],
      fieldLabels: {
        vintages: "年份",
        capitalSource: "资金来源",
        amount: "金额",
      },
      moduleLabel: "品牌资金预算",
    }),
  ],
  data() {
    return {
      isBrandModule: false,
      dataList: [],
      loading: false,
      showDeleteModel: false,
      deteleId: "",
      pagination: {
        total: 0,
        current: 1,
        pageSize: 5,
      },
      columns: columns,
      yearShowOne: false,
      selectedRowKeys: [],
      isEdit: false,
      emptyText: "暂无数据",
      showtable: false,
      id: "",
      title: "",
      sj: {},
      isScore: false,
      isstatus: false,
      showCancelModel: false,
      fieldLabels: FIELD_LABELS[2]["PPZHIJINYUSUAN"],
    };
  },
  props: {
    oldInfos: {
      type: Object,
    },
    cardTitle: {
      type: String,
    },
    isbj: {
      type: Boolean,
      defalt: true,
    },
    isRevise: {
      type: Boolean,
    },
  },
  components: {
    foundSource,
    dataImport,
    evidencelist,
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
      };
    },
  },
  watch: {
    "oldInfos.id": {
      handler(newValue, oldValue) {
        // console.log(newValue, "9999999999999999");
        if (newValue != null && newValue != undefined && newValue) {
          if (
            this.$route.query.new == "preview" ||
            this.$parent?.news == "preview" ||
            (this.$parent.editInfo &&
              this.$parent.editInfo?.type == "preview") ||
            this.oldInfos?.type == "preview"
          ) {
            this.isEdit = true;
          }
          this.ensureStatusColumn(columns);
          this.emptyText = "暂无数据";
          this.foundPay();
        }
        // console.log(newValue, "8989898989");
      },
      deep: true,
      immediate: true,
    },
    isRevise: {
      handler(newValue, oldValue) {
        if (
          this.$route.query.new == "preview" ||
          this.$parent?.news == "preview" ||
          this.$parent?.editInfo?.type == "preview" ||
          this.oldInfos?.type == "preview"
        ) {
          this.isEdit = true;
          return;
        }
        this.isEdit = newValue;
        // 教师角色下， 非负责模块不可编辑
        // if (this.$store.state.role == "teacher-role" && !this.isBrandModule) {
        //   this.isEdit = true;
        // }
      },
      immediate: true,
    },
  },
  mounted() {
    const brandModules = this.$store.state.user.brandModules || ""; // 教师负责模块
    // 是否属于负责模块
    this.isBrandModule = brandModules.includes(this.cardTitle);
    this.isScore =
      this.$store.state.role === "score-role" ||
      this.$store.state.role === "education-role" ||
      this.$store.state.role === "education-guide-role";
    if (!this.oldInfos?.id) {
      this.emptyText = "填写基本信息之后才能添加内容";
    }
    this.isEdit =
      this.$parent.editInfo && this.$parent.editInfo.type == "preview";
    // this.getData();
  },
  methods: {
    cancelInfo(record) {
      this.showCancelModel = true;
      this.sj = record;
    },
    // 新增：处理操作后的数据刷新逻辑
    handleDataAfterOperation(currentPage, totalBefore) {
      // 计算删除后的总数据条数
      const totalAfter = totalBefore - 1;

      if (this.isstatus) {
        // 如果是状态模式，直接刷新数据
        this.getData();
      } else {
        // 计算删除后应该显示的页码
        const pageSize = this.pagination.pageSize;
        const totalPages = Math.ceil(totalAfter / pageSize);

        // 如果当前页没有数据了，且不是第一页，则显示上一页
        if (totalAfter > 0 && currentPage > totalPages) {
          this.pagination.current = Math.max(1, totalPages);
        } else {
          // 否则保持在当前页
          this.pagination.current = currentPage;
        }

        // 刷新数据
        this.getData();
      }
    },
    handleOks() {
      const currentPage = this.pagination.current;
      const totalBeforeCancel = this.pagination.total;
      let data = {
        ids: this.sj.taskId,
      };
      const req =
        this.sj?.status == "1" || this.sj?.status == "3"
          ? postAction("/audit/lxAuditTask/cancelTask?ids=" + this.sj.taskId, data)
          : deleteAction("/audit/lxAuditTask/deleteTaskAndDetail", {
              id: this.sj.taskId,
            });
      req.then((res) => {
        if (res.code === 200) {
          this.$message.success("撤销审核成功");
          this.showCancelModel = false;
          this.handleDataAfterOperation(currentPage, totalBeforeCancel);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    showevidence(record) {
      this.title = "品牌资金预算";
      this.id = this.oldInfos.id;
      this.showtable = true;
      this.sj = record;
    },
    importsj(num) {
      if (num == "1") {
        this.$refs.dataImport.init("fund", this.oldInfos, "资金来源");
      } else if (num == "2") {
        this.$refs.dataImport.init("fundcost", this.oldInfos, "资金支出");
      }
    },
    addSource() {
      // console.log("addSource this.oldInfos", this.oldInfos);
      // console.log("this.$refs.foundSource", this.$refs.foundSource);
      this.$refs.foundSource.init("add", this.oldInfos);
    },
    addPay() {
      this.$refs.foundPay.init("add", this.oldInfos);
    },
    seeInfo(row) {
      this.$refs.foundSource.init("see", row);
    },
    foundPay() {
      if (!this.isstatus) {
        this.pagination.current = 1;
      }
      this.getData();
    },
    getData() {
      this.loading = true;
      // 确保页码不小于1
      if (this.pagination.current < 1) {
        this.pagination.current = 1;
      }
      if (this.isstatus && this.oldInfos?.id) {
        let data = {
          applyType: 2,
          // pageNo: this.pagination.current,
          // pageSize: this.pagination.pageSize,
          applyId: this.oldInfos?.id,
        };
        getAction("/lxBase/lxSubsidyFund/allList", data).then((res) => {
          if (res.code === 200) {
            let data = res.result.records;
            if (data) {
              this.dataList = data;
              console.log(this.dataList, "444444");
              // this.pagination.total = res.result.total;
            }
          }
          this.loading = false;
        });
      } else {
        let data = {
          pageNo: this.pagination.current,
          pageSize: this.pagination.pageSize,
          applyId: this.oldInfos?.id,
          //applyId: "1829722136428707841",
        };
        getAction("/lxBase/lxSubsidyFund/list", data).then((res) => {
          if (res.code === 200) {
            let data = res.result.records;
            if (data) {
              this.dataList = data;
              this.pagination.total = res.result.total;
              // 如果当前页没有数据，且不是第一页，则自动跳转到上一页
              if (data.length === 0 && this.pagination.current > 1) {
                this.pagination.current -= 1;
                this.getData(); // 重新获取上一页数据
                return;
              }
            }
          }
          this.loading = false;
        });
      }
    },
    handleOk() {
      const currentPage = this.pagination.current;
      const pageSize = this.pagination.pageSize;
      const totalBeforeDelete = this.pagination.total;
      if (
        this.sj?.status == "1" ||
        this.sj?.status == "4" ||
        this.sj?.status == "0" ||
        this.sj?.status == "3" ||
        (this.sj?.status == "2" && this.sj?.operation)
      ) {
        deleteAction("/audit/lxAuditTask/deleteTaskAndDetail", {
          id: this.sj.taskId,
        }).then((res) => {
          if (res.code == 200) {
            this.$message.success("移除成功");
            this.showDeleteModel = false;
            this.handleDataAfterOperation(currentPage, totalBeforeDelete);
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        deleteAction("/lxBase/lxSubsidyFund/delete", {
          id: this.deteleId,
          applyId: this.oldInfos?.id,
        }).then((res) => {
          if (res.code == 200) {
            this.$message.success("移除成功");
            this.showDeleteModel = false;
            this.handleDataAfterOperation(currentPage, totalBeforeDelete);
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    deleteInfo(row, index) {
      this.showDeleteModel = true;
      this.sj = row;
      this.deteleId = row.id;
    },
    editInfo(row, index) {
      this.$refs.foundSource.init("edit", row, index);
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.getData();
    },
    option(type) {
      if (type === 1) {
        this.$emit("upStep", this.dataList);
      } else {
        this.$emit("downStep", this.dataList);
      }
    },
    openChangeOne(status) {
      if (status) {
        this.yearShowOne = true;
      }
    },
    handleClearAcquireYear() {
      //  	console.log("111111");
      this.form.year = ""; // 或者适当的空值，根据你的业务需求
    },
    panelChangeOne(value) {
      //   	      console.log(value,"111111");
      this.form.joinYear = value;
      this.$refs.ruleForm.clearValidate("year");
      this.yearShowOne = false;
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    batchDelete() {
      let applyType = 1;
      if (this.$route.name === "szStudio") {
        applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        applyType = 2;
      } else {
        applyType = 3;
      }
      if (this.selectedRowKeys.length == "0") {
        this.$message.warning("请选择要批量移除的预算");
      } else {
        const currentPage = this.pagination.current;
        const totalBeforeDelete = this.pagination.total;
        let params = {
          ids: this.selectedRowKeys.toString(),
          applyId: this.oldInfos?.id,
        };
        deleteAction("/lxBase/lxSubsidyFund/deleteBatch", params).then(
          (res) => {
            if (res.code == 200) {
              this.$message.success("批量移除成功");
              // this.pagination.current = 1;
              // this.getData();
              this.selectedRowKeys = [];

              // 处理批量删除后的页面逻辑
              const deleteCount = this.selectedRowKeys.length;
              const totalAfter = totalBeforeDelete - deleteCount;
              const pageSize = this.pagination.pageSize;
              const totalPages = Math.ceil(totalAfter / pageSize);

              // 如果当前页没有数据了，且不是第一页，则显示上一页
              if (totalAfter > 0 && currentPage > totalPages) {
                this.pagination.current = Math.max(1, totalPages);
              } else {
                // 否则保持在当前页
                this.pagination.current = currentPage;
              }

              this.getData();
              this.$forceUpdate();
            } else {
              this.$message.error(res.message);
            }
          }
        );
      }
    },
  },
};
</script>

<style scoped="scoped" lang="scss">
.statuswz {
  width: 100%;
  height: 54px;
  line-height: 54px;
  cursor: pointer;

  img {
    width: 20px;
    height: auto;
    margin: 0px auto;
  }

  .status-code {
    width: 40px;
    height: 40px;
    background: url("~@/assets/images/green-sj.png") no-repeat;
    background-size: 100% 100%;
    position: absolute;
    right: 0;
    top: 0;
  }
  .status-red {
    background: url("~@/assets/images/red-sj.png") no-repeat;
    background-size: 100% 100%;
  }
  .status-gray {
    background: url("~@/assets/images/hscx.png") no-repeat;
    background-size: 100% 100%;
  }
  .status-orange {
    background: url("~@/assets/images/dtj.png") no-repeat;
    background-size: 100% 100%;
  }
}
.cotainer {
  .submit-btn {
    width: 116px;
    height: 40px;
    margin: 0 auto;
    color: #fff;
    background: #2155b5;
    line-height: 38px;
    text-align: center;
    border-radius: 10px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    cursor: pointer;
  }

  .img-box {
    width: 18px;
    height: 18px;
    margin-right: 9px;
  }

  .img-box-preview {
    width: 21px;
    height: 21px;
    margin-right: 9px;
  }

  .table-content {
    margin: 0 auto;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    width: 100%;
  }

  .table-tr {
    width: 100%;
    display: inline-block;
    text-align: center;
    margin: 0 auto;
    // border-bottom: 1px solid #e8e8e8;
  }
}

.preview-pop-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);

  .preview-box {
    margin: 50px auto;
    width: 1177px;
    height: 90%;
  }

  .preview-boxs {
    margin: 50px auto;
    width: 950px;
    height: 700px;
    overflow: hidden;
  }

  .preview-box-fullscreen {
    width: 100vw;
    height: 100vh;
  }
}
 .btn-action {
    width: 100px;
    height: 30px;
    border-radius: 6px;
    font-weight: 400;
    cursor: pointer;
    line-height: 30px;
    margin-right: 10px;
    text-align: center;
  }
</style>
<style>
.ant-tooltip {
  max-width: 650px;
}
.ant-tooltip-arrow:before {
  background-color: #fff !important;
  width: 10px;
  height: 10px;
}

.ant-tooltip-inner {
  background-color: #fff !important;
  color: #3e3e3e !important;
  box-shadow: 0 0 12px 0 rgba(1, 39, 78, 0.27);
}
</style>